import * as Config from '../../configs/server.configs';

const endPoint = Config[process.env.NODE_ENV].rgbEndpoint;
// const endPoint = 'https://sandboxapi.psd.dnb.no';

export default {
  createAsice: `${endPoint}/asice/v1/create`,
  crsAuthorize: `${endPoint}/crs/v1/authorize`
};
